import type * as Blockly from 'blockly/core';
import {
    expr,
    registerHelperFunction,
    registerSetupCode,
    resolveAnalogPin,
} from '@/(routers)/boards/editor/block/generators/arduino/_gen';

const ALCOHOL_HELPER = (pin: string) => `float _R0_alcohol_${pin} = 0.0;
void _sbeAlcoholCalibrate_${pin}(int pinNumber) {
  float sensorValue = 0.0;
  for (int i = 0; i < 100; i++) {
    sensorValue += analogRead(pinNumber);
  }
  sensorValue = sensorValue / 100.0;
  float sensorVolt = sensorValue / 1023.0 * 5.0;
  if (sensorVolt < 0.01) sensorVolt = 0.01;
  float RS = (5.0 - sensorVolt) / sensorVolt * 200000.0;
  _R0_alcohol_${pin} = RS / 60.0;
}
double _sbeGetAlcohol_${pin}(int pinNumber) {
  int sensorValue = analogRead(pinNumber);
  float sensorVolt = (float)sensorValue / 1023.0 * 5.0;
  if (sensorVolt < 0.01) sensorVolt = 0.01;
  float RS = (5.0 - sensorVolt) / sensorVolt * 200000.0;
  double ratio = RS / _R0_alcohol_${pin};
  if (ratio <= 0) return 0;
  return pow(10, -1.0 * ((log10(ratio) + 0.2391) / 0.6008));
}`;

export function register(gen: any): void {
    gen.forBlock['alcohol'] = function (block: Blockly.Block): [string, number] {
        const { pin } = resolveAnalogPin(block);
        const type = block.getFieldValue('TYPE') as 'RAW' | 'BREATH' | 'BLOOD';

        registerSetupCode(pin, `  pinMode(${pin}, INPUT);\n`);

        if (type === 'BREATH' || type === 'BLOOD') {
            registerHelperFunction(`alcohol_${pin}`, ALCOHOL_HELPER(pin));
            registerSetupCode(`alcohol_calibrate_${pin}`, `  _sbeAlcoholCalibrate_${pin}(${pin});\n`);
            const breathCode = `_sbeGetAlcohol_${pin}(${pin})`;
            if (type === 'BLOOD') {
                return expr(`${breathCode} * 2.0`);
            }
            return expr(breathCode);
        }

        return expr(`analogRead(${pin})`);
    };
}
